import { useCallback } from 'react';
import { Button } from 'components/ui/Button';
import PropTypes from 'prop-types';
import { HOMEPAGE_DASHBOARDS_TRANSLATIONS } from 'const/translations/HomePageDashboards';
import { PillarLoader } from 'components/ui/PillarLoader';
import { APP_MODULES, ROUTES } from 'const';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { HistoryNavigator } from 'shared/lib';
import { waibiAccessRequest } from 'modules/dashboardIndicators/action';
import { selectIsWaibiLoading } from 'modules/dashboardIndicators/selectors';
// import { selectIsShowCarbon } from 'modules/Carbon/selectors';
import { Spinner } from 'components/Spinner';
import Styles from './DashboardIndicators.module.css';

const { WAIBI } = APP_MODULES;
const { ADVANCED_INDICATORS, CARBON_INDICATORS } =
  HOMEPAGE_DASHBOARDS_TRANSLATIONS;

const propTypes = {
  userModules: PropTypes.arrayOf(PropTypes.string),
};

export const DashboardIndicators = ({ userModules }) => {
  const dispatch = useDispatch();
  const isSubscribedToWaibi = userModules.includes(WAIBI);

  const isLoading = useSelector(selectIsWaibiLoading);
  const isShowCarbon = false; // useSelector(selectIsShowCarbon);

  const requestWaibiAccess = useCallback(() => {
    dispatch(
      waibiAccessRequest({
        onError: (errorMessage) => message.error(errorMessage),
      })
    );
  }, [dispatch]);

  const navigateToWaibiLanding = () => {
    HistoryNavigator.navigate(`${ROUTES.WAIBI_LANDING}/?prev=home`);
  };

  const navigateToCarbonFootprint = () => {
    HistoryNavigator.navigate(`${ROUTES.CARBON_FOOTPRINT}/?prev=home`);
  };

  const description = isSubscribedToWaibi ? (
    <p className={Styles.descriptionSubscribed}>
      {ADVANCED_INDICATORS.DESCRIPTION_SUBSCRIBED}
    </p>
  ) : (
    <p>{ADVANCED_INDICATORS.DESCRIPTION_UNSUBSCRIBED}</p>
  );

  return (
    <div className={Styles.indicatorsWrapper}>
      <h3 className={Styles.indicatorsTitle}>{ADVANCED_INDICATORS.TITLE}</h3>
      <div className={Styles.indicatorsDescription}>
        {!isShowCarbon && (
          <PillarLoader colored className={Styles.indicatorsPillars} />
        )}
        {description}
      </div>
      {isSubscribedToWaibi ? (
        <Button
          variant="success"
          className={Styles.indicatorsButton}
          disabled={isLoading}
          onClick={requestWaibiAccess}
          sizeAuto
        >
          {isLoading ? (
            <Spinner className={Styles.indicatorsButtonSpinner} />
          ) : (
            ADVANCED_INDICATORS.BUTTON_SUBSCRIBED
          )}
        </Button>
      ) : (
        <Button
          variant="secondary"
          className={Styles.indicatorsButton}
          onClick={navigateToWaibiLanding}
          sizeAuto
        >
          {ADVANCED_INDICATORS.BUTTON_UNSUBSCRIBED}
        </Button>
      )}
      {isShowCarbon && (
        <>
          <div className={Styles.descriptionLine} />

          <h3 className={Styles.indicatorsTitle}>{CARBON_INDICATORS.TITLE}</h3>
          <div className={Styles.indicatorsDescription}>
            <p>{CARBON_INDICATORS.DESCRIPTION}</p>
          </div>
          <Button
            variant="secondary"
            className={Styles.indicatorsButton}
            onClick={navigateToCarbonFootprint}
            sizeAuto
          >
            {CARBON_INDICATORS.BUTTON}
          </Button>
        </>
      )}
    </div>
  );
};

DashboardIndicators.propTypes = propTypes;
